import useBreakpoint from '@sportson/core-web/hooks/useBreakpoint';
import { ArticleHeroComponent, type ArticleHeroComponentProps } from 'content/ArticleHero';

import { type WordpressHeadingGroup } from 'libs/wordpress/types/contentSystem/groups';
import { type WordpressLinkButton } from 'libs/wordpress/types/contentSystem/elements';
import { transformLinkButton } from 'libs/wordpress/utils/transformButton';
import { transformHeadingGroup } from 'libs/wordpress/utils/transformHeading';
import { ArrowIcon } from 'assets/media/icons/ArrowIcon';

// TODO: MOVE these wp types to correct files
export interface WordpressArticleCustomization {
    tag: string;
    // Note: Add more options if implemented in CMS
}

export interface WordpressArticleSelect {
    article: number;
    customize: WordpressArticleCustomization;
    customized: boolean;
}

export type WordpressArticle = WordpressArticleSelect;

export interface WordpressArticleHeroBlock {
    settings: Array<'heading' | 'button'>;
    heading?: WordpressHeadingGroup;
    button?: WordpressLinkButton;
    article: WordpressArticle;
}

// TODO: Remove Record<string, unknown> when styling is fixed, correctly pass css via rest
export interface ArticleHeroBlockProps extends Record<string, unknown> {
    data: WordpressArticleHeroBlock;
    layout: 'article_hero';
}

const ArticleHeroBlock = ({ data, layout, ...rest }: ArticleHeroBlockProps) => {
    const isMobile = useBreakpoint({ to: 'tablet.sm' });
    const device = isMobile ? 'mobile' : 'desktop';

    const componentData: ArticleHeroComponentProps = {
        articleSelection: null,
    };

    // Heading
    if (data?.settings.includes('heading') && data?.heading) {
        componentData.heading = transformHeadingGroup(data.heading, device);
    }

    // Link Button
    if (data?.settings.includes('button') && data?.button) {
        const transformedButton = transformLinkButton(data.button);
        componentData.button = {
            url: transformedButton.link,
            children: (
                <>
                    {transformedButton.label}
                    {/* TODO: NOTE: Remove ArrowIcon when button i properly styled and fixed */}
                    <ArrowIcon />
                </>
            ),
            theme: transformedButton.theme,
        };
    }

    // Article Selection
    if (data?.article?.article) {
        const articleId = data.article?.article;
        const isCustomized = data.article?.customized;

        if (articleId) {
            componentData.articleSelection = {
                ids: [articleId],
                tag: isCustomized ? data.article?.customize?.tag : '',
            };
        }
    }

    return <ArticleHeroComponent {...componentData} {...rest} />;
};

export default ArticleHeroBlock;
